<style lang="scss" scoped>
// @import 'common/sass/reuse.SCSS';
.grid-content {
  min-height: 45px;
  padding: 20px 20px 25px;
}
.empty {
  padding: 20px;
}
.current-path {
  padding: 10px 20px 5px;
}
.el-breadcrumb {
  line-height: normal;
  font-size: 18px;
}
</style>

<template>
  <div class="maintenance-box">
    <div class="panel">
      <el-row :gutter="1" class="grid-content">
        <el-col :lg="4">
          <el-button :disabled="!folderName" @click="comeBack" type="primary">{{ lan.previous }}</el-button>
        </el-col>
        <el-col :lg="20" class="current-path">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :key="v" v-for="(k, v) in folders">{{ k }}</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-row>
        <el-table :data="tableData" border>
          <el-table-column :label="lan.tableHead.file">
            <template slot-scope="scope">
              <i :class="`el-icon-${scope.row.file ? 'tickets' : 'folder'}`"></i>
              <span :style="`margin-left: 10px;${!scope.row.file ? 'color:#409EFF;' : ''}`">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="lan.tableHead.handle">
            <template slot-scope="scope">
              <el-button @click="downloadFile(scope.row)" size="small" type="text" v-if="scope.row.file">{{ lan.download }}</el-button>
              <el-button @click="openFolder(scope.row)" size="small" type="text" v-else>{{ lan.open }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row :gutter="20" class="grid-content">
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <div class="empty"></div>
        </el-col>
        <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9">
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :page-sizes="[5, 10, 25, 50]"
            :pager-count="5"
            :total="total"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { URL_DOWNLOAD, URL_SEARCH } from 'api/api'

export default {
  mixins: [require('common/mixin/base').base({ lan: 'downloadReport' }), require('common/mixin/base').base({ reuse: 'reuse' })],
  data() {
    return {
      folderName: '',
      all: [],
      tableData: [],
      pageNum: 1,
      pageSize: 5,
      total: 0,
    }
  },
  components: {},
  created() {
    this.searchByFolder()
  },
  computed: {
    folders() {
      return this.folderName.split('/')
    },
  },
  methods: {
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.tableData = this.all.slice(0, val)
    },
    handlePageChange(val) {
      this.pageNum = val
      this.tableData = this.all.slice((val - 1) * this.pageSize, val * this.pageSize)
    },
    comeBack() {
      if (!this.folderName) return
      const folders = this.folderName.split('/')
      folders.pop()
      this.folderName = folders.length > 1 ? folders.join('/') : folders.join('')
      this.searchByFolder()
    },
    downloadFile(row) {
      window.open(`${URL_DOWNLOAD}/${encodeURI(row.name)}?folderName=${encodeURI(this.folderName)}`)
    },
    openFolder(row) {
      this.folderName = `${this.folderName ? `${this.folderName}/` : ''}${row.name}`
      this.searchByFolder()
    },
    searchByFolder() {
      this.$http
        .get(URL_SEARCH, { params: { folderName: this.folderName } })
        .then((res) => {
          if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
            this.all = res.data.data.data
            this.handlePageChange(1)
          } else this.tableData = []
          this.total = this.all.length
        })
        .catch((e) => {
          alert(this.reuse.serverError)
        })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/views/manager-report/download-report.vue